import React from 'react';
import { motion } from 'framer-motion';
import { Card } from '../ui/Card';
import { StatusPill } from '../ui/StatusPill';
import { CalendarIcon, ClockIcon, TagIcon } from 'lucide-react';
import { Bid } from '../../data/bids';
interface BidCardProps {
  bid: Bid;
  index: number;
}
export function BidCard({
  bid,
  index
}: BidCardProps) {
  const daysUntilDeadline = Math.ceil((new Date(bid.deadline).getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24));
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.5,
    delay: index * 0.05
  }} data-id="element-26">
      <Card hover data-id="element-27">
        <div className="flex items-start justify-between mb-3" data-id="element-28">
          <span className="text-sm font-mono text-gray-500" data-id="element-29">
            {bid.reference}
          </span>
          <StatusPill status={bid.status} data-id="element-30">
            {bid.status === 'closing-soon' ? 'CLOSING SOON' : bid.status === 'open' ? 'OPEN' : 'CLOSED'}
          </StatusPill>
        </div>

        <h3 className="text-xl font-bold text-charcoal mb-3" data-id="element-31">{bid.title}</h3>

        <p className="text-gray-600 mb-4 whitespace-pre-line" data-id="element-32">
          {bid.description}
        </p>

        <div className="space-y-2 mb-4" data-id="element-33">
          <div className="flex items-center gap-2 text-sm text-gray-600" data-id="element-34">
            <CalendarIcon size={16} data-id="element-35" />
            <span data-id="element-36">
              Published:{' '}
              {new Date(bid.publicationDate).toLocaleDateString('en-GB')}
            </span>
          </div>

          <div className="flex items-center gap-2 text-sm font-medium text-au-red" data-id="element-37">
            <ClockIcon size={16} data-id="element-38" />
            <span data-id="element-39">
              Deadline: {new Date(bid.deadline).toLocaleDateString('en-GB')}
            </span>
            {bid.status === 'open' && daysUntilDeadline > 0 && <span className="text-gray-500" data-id="element-40">
                ({daysUntilDeadline} days remaining)
              </span>}
          </div>

          <div className="flex items-center gap-2 text-sm text-gray-600" data-id="element-41">
            <TagIcon size={16} data-id="element-42" />
            <span data-id="element-43">{bid.category}</span>
          </div>
        </div>

        {bid.estimatedValue && <div className="pt-4 border-t border-gray-border" data-id="element-44">
            <div className="flex items-center justify-between" data-id="element-45">
              <span className="text-sm text-gray-600" data-id="element-46">Estimated Value</span>
              <span className="text-lg font-bold text-au-green" data-id="element-47">
                {bid.estimatedValue}
              </span>
            </div>
          </div>}
      </Card>
    </motion.div>;
}